import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MeetingsService } from '../meetings.service';
import { LoginService } from '../../login/login.service';
import { cancellable } from '../../shared/cancellable.util';

@Component({
  selector: 'edu-meeting-join',
  standalone: false,
  templateUrl: './meeting-join.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './meeting-join.component.scss',
})
export class MeetingJoinComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  isExpired = false;
  constructor(
    private route: ActivatedRoute,
    private meetingsService: MeetingsService,
    private loginService: LoginService,
    public router: Router,
  ) {}
  async ngOnInit() {
    const meetingId = this.route.snapshot.paramMap.get('id');

    try {
      const { link } = await cancellable(
        this.meetingsService.getMeetingLink$(meetingId!),
        this.destroyRef,
      );
      await cancellable(
        this.meetingsService.joinMeeting$(meetingId!),
        this.destroyRef,
      );
      window.location.href = link;
    } catch (e) {
      // link expired or meeting not found
      this.isExpired = true;
    }
  }
}
